<template>
    <van-popup class="calendar-hour-pop column-fortune-10" :value="showCalendarHourPop" position="bottom"  @click-overlay="clickCancel">
        <div class="column-fortune-14">
            <column-item
                v-for="data in calendarHourList"
                v-bind:key="data.key"
                v-bind:ColumnData="data"
                v-bind:columnFateData="{}"
                v-bind:clickFunc="clickItem"
            ></column-item>
        </div>
    </van-popup>
</template>

<script>
import ColumnItem from "../../components/ColumnItem.vue";
export default {
    name: 'CalendarHourPop',
    components: { ColumnItem },
    computed: {
        showCalendarHourPop() {
            return this.$store.state.calendar.showCalendarHourPop;
        },
        calendarHourList() {
            return this.$store.state.calendar.calendarHourList;
        }
    },
    methods: {
        clickCancel() {
            this.$store.state.calendar.showCalendarHourPop = false;
        },
        clickItem(data) {
            this.$store.dispatch('calendar/updateCalendarHour', data);
            this.$store.state.calendar.showCalendarHourPop = false;
        }
    }
}
</script>